module.exports = __webpack_public_path__ + "static/media/ImporterStep3.3c0c2122.svg";